import { render } from "./RoulettePopup.vue?vue&type=template&id=6a5a0024&scoped=true"
import script from "./RoulettePopup.vue?vue&type=script&lang=js"
export * from "./RoulettePopup.vue?vue&type=script&lang=js"

import "./RoulettePopup.vue?vue&type=style&index=0&id=6a5a0024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5a0024"]])

export default __exports__